var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrymyaiClawson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 280.031,
    height: 113.888,
    viewBox: "0 0 280.031 113.888",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35322",
    "data-name": "Path 35322",
    d: "M44.934,0a52.31,52.31,0,1,1,0,104.62c-28.89,0-56.612-25.072-56.612-53.962S16.043,0,44.934,0Z",
    transform: "translate(11.679 0)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15460",
    "data-name": "Rectangle 15460",
    width: 100.542,
    height: 126.793,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35222",
    "data-name": "Path 35222",
    d: "M213.67,518.164l-2.591,9.709,13.533-.176-2.89-9.723Z",
    transform: "translate(-211.079 -517.974)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35227",
    "data-name": "Path 35227",
    d: "M188.493,102.7c-2.232,4.783-9.423,28.443-9.552,29.606-.156,1.513-1.73,5.712,1.8,23.62,3.711,18.818,7.679,39.819,7.679,39.819l7.943.136s4.03-21.133,7.733-39.957c3.531-17.909,1.96-22.108,1.8-23.62-.122-1.16-7.313-24.821-9.538-29.6-.324-.7-2.171-1.061-4-1.061-1.773,0-3.528.343-3.862,1.061",
    transform: "translate(-178.457 -101.644)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35231",
    "data-name": "Path 35231",
    d: "M189.859,349.038,196.8,385.12l8.818-.034,7.136-36.583Z",
    transform: "translate(-189.859 -348.503)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35235",
    "data-name": "Path 35235",
    d: "M205.7,121.768a3.276,3.276,0,1,0,3.276-3.276,3.276,3.276,0,0,0-3.276,3.276",
    transform: "translate(-205.699 -118.492)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35238",
    "data-name": "Path 35238",
    d: "M248.474,121.768a3.276,3.276,0,1,0,3.276-3.276,3.276,3.276,0,0,0-3.276,3.276",
    transform: "translate(-248.474 -118.492)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35245",
    "data-name": "Path 35245",
    d: "M316.485,75.312l-.841.068-.963-7.584c-17.041,9.755-9.375,24.679-9.375,24.679l-13.71,9.517s17.2,11.234,31.449-7.476a6.891,6.891,0,0,0,.719-1.221c9.055-20.466-8.758-30.75-8.758-30.75Z",
    transform: "translate(-291.596 -62.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35248",
    "data-name": "Path 35248",
    d: "M7.249,126.756a5.852,5.852,0,0,0,1.082.921C27.9,140.728,40.507,124.5,40.507,124.5l-16.063-4.527s2.389-16.6-16.906-20.275l1.555,7.478-.816.2L5.508,94.833s-13.483,15.533,1.741,31.923",
    transform: "translate(0 -94.833)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35252",
    "data-name": "Path 35252",
    d: "M280.659,215.784l-.034,2.632,8.154.641.794-4.782.461-2.774.448-.377-.2-1.031Z",
    transform: "translate(-280.625 -210.093)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35255",
    "data-name": "Path 35255",
    d: "M146.414,224.2l-.91,2.658-.505.307.03,1.056,10.423-4.034.469-2.586-7.943-1.981Z",
    transform: "translate(-144.998 -219.624)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25385",
    "data-name": "Group 25385",
    transform: "translate(-799.748 -277.019)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1027",
    "data-name": "Ellipse 1027",
    cx: 49.476,
    cy: 49.813,
    rx: 49.476,
    ry: 49.813,
    transform: "translate(890.624 291.282)",
    fill: "#009081",
    opacity: 0.995
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_410",
    "data-name": "Mask Group 410",
    transform: "translate(884.998 286.287)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14232",
    "data-name": "Group 14232",
    transform: "translate(2.186 12.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14195",
    "data-name": "Group 14195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14194",
    "data-name": "Group 14194",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35201",
    "data-name": "Path 35201",
    d: "M166.975,357.484a.505.505,0,0,0-.5-.475h-9.518a.25.25,0,0,0-.251.249v0a.25.25,0,0,0,.249.251h9.987a.025.025,0,0,0,.02-.007c.014.007.014.007.014-.02",
    transform: "translate(-121.341 -276.441)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35202",
    "data-name": "Path 35202",
    d: "M120.363,324.283l-8.955-8.954a.031.031,0,0,0-.034,0l-.163.163a.247.247,0,0,0,0,.35l0,0,8.615,8.615a.248.248,0,0,0,.351,0l0,0Z",
    transform: "translate(-86.056 -244.164)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35203",
    "data-name": "Path 35203",
    d: "M149.912,352.862a1.085,1.085,0,1,1-1.085,1.085,1.085,1.085,0,0,1,1.085-1.085m0,.393a.692.692,0,1,1-.692.692.7.7,0,0,1,.692-.692",
    transform: "translate(-115.24 -273.23)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35204",
    "data-name": "Path 35204",
    d: "M278.531,357.261a.25.25,0,0,1,.249-.251h9.987a.032.032,0,0,1,.034.031v0a.5.5,0,0,1-.5.475h-9.518A.261.261,0,0,1,278.531,357.261Z",
    transform: "translate(-215.673 -276.442)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35205",
    "data-name": "Path 35205",
    d: "M329.287,324.783a.247.247,0,0,1,0-.35l0,0,8.615-8.615a.247.247,0,0,1,.35,0l0,0,.176.176-8.955,8.954a.03.03,0,0,1-.034,0Z",
    transform: "translate(-254.918 -244.486)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35206",
    "data-name": "Path 35206",
    d: "M323.382,352.862a1.085,1.085,0,1,0,1.085,1.085,1.085,1.085,0,0,0-1.085-1.085m0,.393a.692.692,0,1,0,.692.692.692.692,0,0,0-.692-.692",
    transform: "translate(-249.563 -273.23)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35207",
    "data-name": "Path 35207",
    d: "M182.726,390.223a.5.5,0,0,1-.5.5h-9.519a.251.251,0,0,1,0-.5h9.519a.5.5,0,0,1,.5.5v-.5Z",
    transform: "translate(-133.537 -302.159)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35208",
    "data-name": "Path 35208",
    d: "M145.807,393.579l-6.125,6.125a.026.026,0,0,1-.036,0l0,0-.163-.163a.254.254,0,0,1,0-.353l5.786-5.787a.254.254,0,0,1,.353,0Z",
    transform: "translate(-107.946 -304.566)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35209",
    "data-name": "Path 35209",
    d: "M165.7,389.118a1.085,1.085,0,1,0-1.085-1.085,1.085,1.085,0,0,0,1.085,1.085m0-.393a.692.692,0,1,0-.692-.692.678.678,0,0,0,.665.692Z",
    transform: "translate(-127.462 -299.623)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35210",
    "data-name": "Path 35210",
    d: "M262.781,390.451a.25.25,0,0,0,.249.251h9.994a.032.032,0,0,0,.034-.029.017.017,0,0,0,0,0,.5.5,0,0,0-.5-.475h-9.518a.262.262,0,0,0-.258.258",
    transform: "translate(-203.478 -302.136)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35211",
    "data-name": "Path 35211",
    d: "M313.546,393.053a.254.254,0,0,0,0,.353l5.786,5.786a.254.254,0,0,0,.353,0l.176-.176-6.126-6.126a.026.026,0,0,0-.036,0l0,0Z",
    transform: "translate(-242.731 -304.216)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35212",
    "data-name": "Path 35212",
    d: "M307.633,389.118a1.085,1.085,0,1,1,1.085-1.085,1.085,1.085,0,0,1-1.085,1.085m0-.393a.692.692,0,1,1,.692-.692.692.692,0,0,1-.692.692Z",
    transform: "translate(-237.368 -299.623)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35213",
    "data-name": "Path 35213",
    d: "M200.5,398.892l-7.245,7.244a.019.019,0,0,1-.025.009.02.02,0,0,1-.009-.009l-.163-.163a.248.248,0,0,1,0-.35l0,0,6.905-6.905a.247.247,0,0,1,.35,0l0,0Z",
    transform: "translate(-149.436 -308.678)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35214",
    "data-name": "Path 35214",
    d: "M190.481,436.665v6.627h-.251a.255.255,0,0,1-.251-.251v-6.119a.254.254,0,0,1,.251-.251Z",
    transform: "translate(-147.105 -338.121)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35215",
    "data-name": "Path 35215",
    d: "M188.5,430.642a1.089,1.089,0,1,0-1.54,0h0a1.091,1.091,0,0,0,1.54,0m-.278-.278a.7.7,0,1,0-.007.007l.007-.007",
    transform: "translate(-144.523 -332.017)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35216",
    "data-name": "Path 35216",
    d: "M255.013,398.409a.248.248,0,0,0,0,.351l0,0,6.905,6.905a.248.248,0,0,0,.351,0l0,0,.176-.176-7.235-7.235a.02.02,0,0,0-.027-.007.019.019,0,0,0-.007.007Z",
    transform: "translate(-197.406 -308.371)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35217",
    "data-name": "Path 35217",
    d: "M288.821,436.642a.255.255,0,0,0-.251.251v6.119a.255.255,0,0,0,.251.251h.251v-6.628Z",
    transform: "translate(-223.447 -338.097)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35218",
    "data-name": "Path 35218",
    d: "M284.77,430.642a1.089,1.089,0,1,1,1.54,0h0a1.091,1.091,0,0,1-1.54,0m.278-.278a.7.7,0,1,1,.007.007l-.007-.007",
    transform: "translate(-220.257 -332.017)",
    fill: "#023",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14197",
    "data-name": "Group 14197",
    transform: "translate(47.635 116.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14196",
    "data-name": "Group 14196",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35219",
    "data-name": "Path 35219",
    d: "M221.024,519.318a1.133,1.133,0,1,1-2.266-.007v.007a1.169,1.169,0,0,1-1.131,1.187,1.1,1.1,0,0,1-.793-.339,1.532,1.532,0,0,1-1.682.7,1.648,1.648,0,0,1-1.141-1.979c.516-2.2,1.445-6.146,1.967-8.336a1.557,1.557,0,0,1,1.845-1.2l.039.009a1.3,1.3,0,0,1,1.031,1.7l-.027.122h1.865l-.027-.122c-.21-.875.407-1.485,1.241-1.7a1.553,1.553,0,0,1,1.874,1.147c0,.016.007.031.01.047.516,2.2,1.445,6.139,1.967,8.336a1.647,1.647,0,0,1-1.14,1.981,1.527,1.527,0,0,1-1.689-.712,1.121,1.121,0,0,1-.8.353,1.166,1.166,0,0,1-1.13-1.194Z",
    transform: "translate(-213.311 -511.266)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35220",
    "data-name": "Path 35220",
    d: "M242.278,525.934l1.364.068.014-2.411.678,2.367,1.153-.528-1.92-7.137-1.275.014Z",
    transform: "translate(-235.237 -518.221)",
    fill: "#fac2c6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35221",
    "data-name": "Path 35221",
    d: "M228.835,525.934l-1.364.068-.014-2.411-.678,2.367-1.153-.528,1.92-7.137,1.275.014Z",
    transform: "translate(-222.344 -518.221)",
    fill: "#fac2c6",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14199",
    "data-name": "Group 14199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14198",
    "data-name": "Group 14198",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35223",
    "data-name": "Path 35223",
    d: "M188.49,102.706c.678-1.458,7.224-1.37,7.862,0,2.225,4.782,9.416,28.443,9.538,29.6.163,1.513,1.733,5.712-1.8,23.621-3.7,18.824-7.734,39.958-7.734,39.958l-7.943-.136s-3.968-21-7.679-39.819c-3.527-17.908-1.953-22.108-1.8-23.62.129-1.162,7.32-24.823,9.551-29.606",
    transform: "translate(-138.182 -78.706)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14201",
    "data-name": "Group 14201",
    transform: "translate(40.273 22.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14200",
    "data-name": "Group 14200",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35224",
    "data-name": "Path 35224",
    d: "M181.743,301.821l26.422.156-6.274,48.705-13.527.2Z",
    transform: "translate(-181.002 -256.646)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15462",
    "data-name": "Rectangle 15462",
    width: 29.603,
    height: 0.563,
    transform: "translate(-1.673 45.175)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15463",
    "data-name": "Rectangle 15463",
    width: 29.603,
    height: 0.563,
    transform: "translate(-1.673 59.895)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15464",
    "data-name": "Rectangle 15464",
    width: 29.603,
    height: 0.563,
    transform: "translate(-1.673 71.543)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15465",
    "data-name": "Rectangle 15465",
    width: 29.603,
    height: 0.563,
    transform: "translate(-1.673 83.183)",
    fill: "#023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35225",
    "data-name": "Path 35225",
    d: "M208.188,117.38a3.541,3.541,0,1,1-3.541,3.541,3.541,3.541,0,0,1,3.541-3.541",
    transform: "translate(-198.737 -113.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35226",
    "data-name": "Path 35226",
    d: "M250.962,117.38a3.541,3.541,0,1,1-3.541,3.541,3.541,3.541,0,0,1,3.541-3.541",
    transform: "translate(-231.858 -113.829)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14203",
    "data-name": "Group 14203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14202",
    "data-name": "Group 14202",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35228",
    "data-name": "Path 35228",
    d: "M189.859,349.036l6.939,36.082,8.818-.034,7.136-36.584Z",
    transform: "translate(-147.012 -269.852)",
    fill: "#3e5d8b",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14205",
    "data-name": "Group 14205",
    transform: "translate(42.847 78.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14204",
    "data-name": "Group 14204",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35229",
    "data-name": "Path 35229",
    d: "M191.333,349.581l.122,3.941-3.31,2.823,1.988,19.618-1.458-19.129,3.425-3.241-.244-4.09Z",
    transform: "translate(-188.532 -349.276)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35230",
    "data-name": "Path 35230",
    d: "M275.781,349.581l-.122,3.941,3.31,2.823-1.988,19.618,1.459-19.129-3.426-3.241.244-4.09Z",
    transform: "translate(-255.797 -349.276)",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14207",
    "data-name": "Group 14207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14206",
    "data-name": "Group 14206",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35232",
    "data-name": "Path 35232",
    d: "M217.061,497.189l10.827-.346.115,3.241-10.82.353Z",
    transform: "translate(-168.075 -384.718)",
    fill: "#587cb2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35233",
    "data-name": "Path 35233",
    d: "M208.974,118.492a3.276,3.276,0,1,1-3.276,3.276,3.276,3.276,0,0,1,3.276-3.276",
    transform: "translate(-159.277 -91.751)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14209",
    "data-name": "Group 14209",
    transform: "translate(46.421 26.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14208",
    "data-name": "Group 14208",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35234",
    "data-name": "Path 35234",
    d: "M209.1,111.489a3.216,3.216,0,1,1-3.276,3.215,3.246,3.246,0,0,1,3.276-3.215",
    transform: "translate(-205.792 -113.069)",
    fill: "#023"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14211",
    "data-name": "Group 14211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14210",
    "data-name": "Group 14210",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35236",
    "data-name": "Path 35236",
    d: "M251.749,118.492a3.276,3.276,0,1,1-3.276,3.276,3.276,3.276,0,0,1,3.276-3.276",
    transform: "translate(-192.399 -91.751)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14213",
    "data-name": "Group 14213",
    transform: "translate(56.074 26.741)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14212",
    "data-name": "Group 14212",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35237",
    "data-name": "Path 35237",
    d: "M251.869,111.489a3.216,3.216,0,1,1-3.276,3.215,3.246,3.246,0,0,1,3.276-3.215",
    transform: "translate(-248.566 -113.069)",
    fill: "#023"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14215",
    "data-name": "Group 14215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14214",
    "data-name": "Group 14214",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35239",
    "data-name": "Path 35239",
    d: "M250.043,10l-.231-.034a.237.237,0,0,0-.271.2l-3.181,20.8a.237.237,0,0,0,.2.271l.2.034c.014,0,.027-.007.027-.021Z",
    transform: "translate(-190.76 -7.717)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35240",
    "data-name": "Path 35240",
    d: "M256.386,0a1.6,1.6,0,1,1-1.6,1.6,1.6,1.6,0,0,1,1.6-1.6",
    transform: "translate(-197.286)",
    fill: "#f14a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35241",
    "data-name": "Path 35241",
    d: "M218.223,10.373a.237.237,0,0,1,.2-.271l.2-.034c.014,0,.027.007.027.021l3.37,21.212-.231.034a.238.238,0,0,1-.271-.2Z",
    transform: "translate(-168.973 -7.796)",
    fill: "#023",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35242",
    "data-name": "Path 35242",
    d: "M213.371.24a1.6,1.6,0,1,1-1.6,1.6,1.6,1.6,0,0,1,1.6-1.6",
    transform: "translate(-163.979 -0.186)",
    fill: "#f14a58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35243",
    "data-name": "Path 35243",
    d: "M291.6,101.992l13.71-9.518s-7.666-14.923,9.375-24.679l.963,7.584.841-.068-1.479-12.767s17.813,10.284,8.758,30.75a6.889,6.889,0,0,1-.719,1.221c-14.246,18.71-31.449,7.476-31.449,7.476",
    transform: "translate(-225.792 -48.43)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14217",
    "data-name": "Group 14217",
    transform: "translate(65.806 14.115)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14216",
    "data-name": "Group 14216",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35244",
    "data-name": "Path 35244",
    d: "M298.68,195.171l20.494,1.988L294.7,215.2l-11.668-8.127v-5.026Z",
    transform: "translate(-284.963 -165.24)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_730",
    "data-name": "Line 730",
    x2: 1.187,
    y2: 6.715,
    transform: "translate(3.276 36.145)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_731",
    "data-name": "Line 731",
    x2: 12.143,
    y2: 10.033,
    transform: "translate(8.052 32.589)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_732",
    "data-name": "Line 732",
    x2: 19.848,
    y2: 2.211,
    transform: "translate(12.706 29.686)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14219",
    "data-name": "Group 14219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14218",
    "data-name": "Group 14218",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35246",
    "data-name": "Path 35246",
    d: "M40.507,124.5l-16.063-4.527s2.389-16.6-16.905-20.275l1.555,7.478-.816.2L5.508,94.833s-13.483,15.533,1.741,31.923a5.859,5.859,0,0,0,1.082.921C27.9,140.728,40.507,124.5,40.507,124.5",
    transform: "translate(0 -73.432)",
    fill: "#f88b93",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14221",
    "data-name": "Group 14221",
    transform: "translate(0 21.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14220",
    "data-name": "Group 14220",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35247",
    "data-name": "Path 35247",
    d: "M44.054,206.234l-18.72,8.558,29.019,9.069,8.372-11.478-1.639-4.752Z",
    transform: "translate(-19.616 -181.094)",
    fill: "#f14a58",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_733",
    "data-name": "Line 733",
    x2: 1.067,
    y2: 6.741,
    transform: "translate(36.33 27.615)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_734",
    "data-name": "Line 734",
    x1: 8.209,
    y2: 13.446,
    transform: "translate(22.448 25.804)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_735",
    "data-name": "Line 735",
    x1: 18.042,
    y2: 8.558,
    transform: "translate(7.263 24.58)",
    fill: "none",
    stroke: "#023",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14223",
    "data-name": "Group 14223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14222",
    "data-name": "Group 14222",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35249",
    "data-name": "Path 35249",
    d: "M191.667,238.413a19.79,19.79,0,0,1-3.371-.468c-1.784-.292-5.61-.9-7.7,0s-1.055-3.778-1.323-4.911-1.818-13.19-1.733-15.568-.054-4.077,2.563-12.916c0,0,7.7,5.786,11.553,5.786s11.557-5.786,11.557-5.786c2.618,8.839,2.469,10.535,2.563,12.916s-1.465,14.435-1.733,15.568.766,5.8-1.323,4.911-5.909-.292-7.7,0a18.912,18.912,0,0,1-3.352.468",
    transform: "translate(-137.472 -158.388)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35250",
    "data-name": "Path 35250",
    d: "M288.756,219.023l.794-4.782.461-2.774.448-.387-.2-1.031-9.619,5.691-.041,2.632Z",
    transform: "translate(-217.272 -162.646)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14225",
    "data-name": "Group 14225",
    transform: "translate(63.33 47.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14224",
    "data-name": "Group 14224",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35251",
    "data-name": "Path 35251",
    d: "M323.534,215.317l-1.37-4.382.3-1.608Z",
    transform: "translate(-312.789 -209.5)",
    fill: "#011b2a",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14227",
    "data-name": "Group 14227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14226",
    "data-name": "Group 14226",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35253",
    "data-name": "Path 35253",
    d: "M147.973,219.621l-1.562,4.581-.91,2.658-.505.307.029,1.056,10.423-4.034.469-2.586Z",
    transform: "translate(-112.274 -170.058)",
    fill: "#d0e5e1",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14229",
    "data-name": "Group 14229",
    transform: "translate(32.722 49.564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14228",
    "data-name": "Group 14228",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35254",
    "data-name": "Path 35254",
    d: "M144.6,231.471l.63,4.552-.573,1.534Z",
    transform: "translate(-144.688 -228.798)",
    fill: "#011b2a",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14231",
    "data-name": "Group 14231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14230",
    "data-name": "Group 14230",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35256",
    "data-name": "Path 35256",
    d: "M200.5,212.513c4.938-.461,11.573-7.964,11.573-7.964l.17.577c-5.766,6.085-9.456,7.666-11.776,8-2.286-.332-5.929-1.913-11.627-7.989l.169-.576s6.58,7.529,11.465,7.964Z",
    transform: "translate(-146.22 -158.387)",
    fill: "#088e80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15473",
    "data-name": "Rectangle 15473",
    width: 0.4,
    height: 1.547,
    transform: "translate(54.073 54.106)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35257",
    "data-name": "Path 35257",
    d: "M223.166,244.2a.091.091,0,0,0-.087-.1H209.1a.144.144,0,0,0-.075.027.115.115,0,0,0-.02.068v5.386a.091.091,0,0,0,.087.095h13.975a.142.142,0,0,0,.075-.027.116.116,0,0,0,.02-.068Z",
    transform: "translate(-161.835 -189.019)",
    fill: "#088e80",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35258",
    "data-name": "Path 35258",
    d: "M224.569,246.786a.076.076,0,0,0-.027-.068.088.088,0,0,0-.068-.027H211.653a.076.076,0,0,0-.068.027.087.087,0,0,0-.027.068v4.206a.075.075,0,0,0,.027.068.086.086,0,0,0,.068.027h12.821a.075.075,0,0,0,.068-.027.087.087,0,0,0,.027-.068Z",
    transform: "translate(-163.814 -191.019)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35259",
    "data-name": "Path 35259",
    d: "M217.224,253.771l.21.054a.706.706,0,0,1-.244.407.69.69,0,0,1-.427.142.7.7,0,0,1-.42-.109.654.654,0,0,1-.244-.312,1.113,1.113,0,0,1-.088-.441.934.934,0,0,1,.1-.448.7.7,0,0,1,.271-.292.788.788,0,0,1,.393-.1.615.615,0,0,1,.631.475l-.21.047a.5.5,0,0,0-.163-.258.408.408,0,0,0-.264-.081.521.521,0,0,0-.312.088.5.5,0,0,0-.176.244.975.975,0,0,0-.054.312,1.125,1.125,0,0,0,.061.366.474.474,0,0,0,.183.231.435.435,0,0,0,.271.075.469.469,0,0,0,.3-.109.394.394,0,0,0,.187-.292",
    transform: "translate(-167.261 -195.65)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35260",
    "data-name": "Path 35260",
    d: "M223.463,254.459v-1.635h.21v1.445h.793v.19Z",
    transform: "translate(-173.033 -195.768)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35261",
    "data-name": "Path 35261",
    d: "M228.272,254.46l.617-1.635h.231l.658,1.635h-.237l-.19-.5h-.672l-.176.5Zm.461-.672h.543l-.169-.452c-.054-.136-.088-.251-.115-.339a1.628,1.628,0,0,1-.088.312Z",
    transform: "translate(-176.757 -195.769)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35262",
    "data-name": "Path 35262",
    d: "M235.075,254.459l-.427-1.635h.217l.244,1.072c.027.115.048.226.068.339.041-.176.068-.278.075-.3l.3-1.106h.258l.231.829a4.222,4.222,0,0,1,.122.583c.02-.1.047-.226.081-.36l.251-1.051h.217l-.441,1.635h-.2l-.339-1.248c-.027-.109-.047-.17-.047-.19l-.047.19-.339,1.248Z",
    transform: "translate(-181.694 -195.768)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35263",
    "data-name": "Path 35263",
    d: "M244.386,253.844l.2-.02a.427.427,0,0,0,.068.2.339.339,0,0,0,.163.129.625.625,0,0,0,.244.047.714.714,0,0,0,.21-.034.347.347,0,0,0,.143-.1.256.256,0,0,0,.047-.142.244.244,0,0,0-.041-.136.271.271,0,0,0-.151-.1,2.238,2.238,0,0,0-.285-.081,1.287,1.287,0,0,1-.312-.1.394.394,0,0,1-.226-.359.458.458,0,0,1,.068-.231.439.439,0,0,1,.2-.163.742.742,0,0,1,.292-.054.857.857,0,0,1,.319.061.469.469,0,0,1,.21.169.578.578,0,0,1,.081.258l-.2.014a.325.325,0,0,0-.109-.237.419.419,0,0,0-.278-.081.442.442,0,0,0-.278.075.226.226,0,0,0-.088.176.186.186,0,0,0,.061.143.818.818,0,0,0,.319.115,2.187,2.187,0,0,1,.359.109.45.45,0,0,1,.2.169.4.4,0,0,1,.068.231.433.433,0,0,1-.075.244.443.443,0,0,1-.21.176.613.613,0,0,1-.312.061.969.969,0,0,1-.366-.061.5.5,0,0,1-.231-.2.479.479,0,0,1-.091-.286",
    transform: "translate(-189.234 -195.675)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35264",
    "data-name": "Path 35264",
    d: "M251.024,253.571a.9.9,0,0,1,.217-.638.717.717,0,0,1,.556-.231.754.754,0,0,1,.4.108.663.663,0,0,1,.271.305,1.044,1.044,0,0,1-.007.889.659.659,0,0,1-.278.3.764.764,0,0,1-.387.1.725.725,0,0,1-.407-.115.74.74,0,0,1-.271-.3,1.022,1.022,0,0,1-.095-.42m.226,0a.687.687,0,0,0,.156.468.537.537,0,0,0,.759.021h0c.007-.007.02-.014.027-.027a.716.716,0,0,0,.156-.488.906.906,0,0,0-.068-.353.5.5,0,0,0-.2-.231.534.534,0,0,0-.285-.081.548.548,0,0,0-.387.156A.753.753,0,0,0,251.25,253.571Z",
    transform: "translate(-194.373 -195.674)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35265",
    "data-name": "Path 35265",
    d: "M259.054,254.459v-1.635h.217l.838,1.289v-1.289h.2v1.635H260.1l-.841-1.289v1.289Z",
    transform: "translate(-200.592 -195.768)",
    fill: "#088e80"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35266",
    "data-name": "Path 35266",
    d: "M235.013,170.735a2.959,2.959,0,0,1-2.761,2.761,2.924,2.924,0,0,1-2.727-2.544.175.175,0,0,1,.136-.208l.015,0h.156a2.7,2.7,0,0,0,2.421,2.327,2.667,2.667,0,0,0,2.395-2.2.16.16,0,0,1,.156-.115,1.7,1.7,0,0,1,.209-.014",
    transform: "translate(-177.724 -132.204)",
    fill: "#023",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24864",
    "data-name": "Group 24864",
    transform: "translate(799.748 277.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46961",
    "data-name": "Path 46961",
    d: "M2238.336,185.39l-1.855,1.8-3.233-2.664-3.038,2.3-2.745-1.6-.809,1.39,3.672,2.137,2.879-2.183,3.363,2.771,2.791-2.715Z",
    transform: "translate(-1966.022 -162.931)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46992",
    "data-name": "Path 46992",
    d: "M2238.336,185.39l-1.855,1.8-3.233-2.664-3.038,2.3-2.745-1.6-.809,1.39,3.672,2.137,2.879-2.183,3.363,2.771,2.791-2.715Z",
    transform: "translate(-1990.928 -129.947)",
    fill: "#06233d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24865",
    "data-name": "Group 24865",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24867",
    "data-name": "Group 24867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46962",
    "data-name": "Path 46962",
    d: "M443.742,287.953l-1.533-2.112-2.609.065a.359.359,0,0,1-.3-.569l1.535-2.11-.868-2.461a.359.359,0,0,1,.449-.46l2.481.808,2.072-1.586a.359.359,0,0,1,.577.285l0,2.61L447.7,283.9a.359.359,0,0,1-.093.636l-2.482.8-.744,2.5a.359.359,0,0,1-.634.108",
    transform: "translate(-387.82 -246.742)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46989",
    "data-name": "Path 46989",
    d: "M443.742,287.953l-1.533-2.112-2.609.065a.359.359,0,0,1-.3-.569l1.535-2.11-.868-2.461a.359.359,0,0,1,.449-.46l2.481.808,2.072-1.586a.359.359,0,0,1,.577.285l0,2.61L447.7,283.9a.359.359,0,0,1-.093.636l-2.482.8-.744,2.5a.359.359,0,0,1-.634.108",
    transform: "translate(-383.834 -204.334)",
    fill: "#ea555f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46963",
    "data-name": "Path 46963",
    d: "M1854.6,58.815l-2.07-.473.393-3.415-2.941-1.064-.124-2.6-1.318.063.166,3.482,2.787,1.009-.408,3.552,3.115.711Z",
    transform: "translate(-1632.162 -45.26)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46964",
    "data-name": "Path 46964",
    d: "M385.734,111.632l-1.568-2.268-2.758.006a.379.379,0,0,1-.3-.609l1.673-2.193-.858-2.621a.379.379,0,0,1,.486-.475l2.6.913,2.228-1.626a.379.379,0,0,1,.6.315l-.064,2.757,2.235,1.616a.379.379,0,0,1-.113.67l-2.642.791-.846,2.625a.379.379,0,0,1-.672.1",
    transform: "translate(-336.427 -90.666)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46991",
    "data-name": "Path 46991",
    d: "M383.458,107.3l-.81-1.171-1.424,0a.2.2,0,0,1-.156-.314l.864-1.132-.443-1.353a.2.2,0,0,1,.251-.246l1.344.471,1.15-.84a.2.2,0,0,1,.311.163l-.033,1.424,1.154.834a.2.2,0,0,1-.059.346l-1.364.408-.437,1.355a.2.2,0,0,1-.347.051",
    transform: "translate(-310.175 -47.564)",
    fill: "#f47458"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46966",
    "data-name": "Path 46966",
    d: "M1092.98,5.905l-2.966.98-2.1-4.6-4.514.9L1081.26,0l-1.612,1.082,2.858,4.258,4.277-.85,2.188,4.784,4.463-1.474Z",
    transform: "translate(-953.273)",
    fill: "#f7cc7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46967",
    "data-name": "Path 46967",
    d: "M2323.062,322.174l-2.708.366-1.233,2.439a.376.376,0,0,1-.674-.007l-1.185-2.462-2.7-.42a.375.375,0,0,1-.2-.642l1.976-1.888-.436-2.7a.376.376,0,0,1,.549-.39l2.406,1.3,2.431-1.248a.376.376,0,0,1,.541.4l-.489,2.689,1.938,1.927a.376.376,0,0,1-.215.638",
    transform: "translate(-2043.356 -279.388)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46993",
    "data-name": "Path 46993",
    d: "M2323.062,322.174l-2.708.366-1.233,2.439a.376.376,0,0,1-.674-.007l-1.185-2.462-2.7-.42a.375.375,0,0,1-.2-.642l1.976-1.888-.436-2.7a.376.376,0,0,1,.549-.39l2.406,1.3,2.431-1.248a.376.376,0,0,1,.541.4l-.489,2.689,1.938,1.927a.376.376,0,0,1-.215.638",
    transform: "translate(-2077.652 -244.525)",
    fill: "#3e5d8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46968",
    "data-name": "Path 46968",
    d: "M564.637,110.107l-3.263.13-1.284,3.072-3.668-.113-.358,3.694-4.153.055-.749,3.361-3.987.707-.267-1.509,2.981-.528.791-3.546,3.992-.053.364-3.756,4.047.124,1.254-3,3.024-.121.411-2.142,1.505.289Z",
    transform: "translate(-482.892 -94.018)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46969",
    "data-name": "Path 46969",
    d: "M849.237,41.264a2.672,2.672,0,0,1,1.69-1.547A2.069,2.069,0,0,1,853.56,41.1c.4,1.258-.219,3.1-2.666,5.315-3.279-.372-4.86-1.506-5.265-2.763a2.069,2.069,0,0,1,1.333-2.657,2.672,2.672,0,0,1,2.275.271",
    transform: "translate(-746.55 -34.975)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46970",
    "data-name": "Path 46970",
    d: "M792.129,72.5a27.538,27.538,0,0,0,3.084-.636c.306-.082.862-.133,1-.452a.334.334,0,0,0-.113-.443c-.294-.194-.728.029-1.037.111-.941.25-2.018.489-3.12.667a.391.391,0,0,0-.285.468.4.4,0,0,0,.468.285",
    transform: "translate(-698.987 -62.595)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46971",
    "data-name": "Path 46971",
    d: "M931.954,58.966c.452-.112.9-.233,1.353-.352a4.268,4.268,0,0,0,1.33-.429.336.336,0,0,0-.153-.625,4.218,4.218,0,0,0-1.363.285c-.45.121-.9.24-1.349.368a.388.388,0,0,0,.183.753",
    transform: "translate(-822.456 -50.818)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46972",
    "data-name": "Path 46972",
    d: "M838.819,106.007a4.848,4.848,0,0,1,1.357-2.074.314.314,0,0,0-.366-.5,3.606,3.606,0,0,0-1.735,2.364.386.386,0,0,0,.743.209",
    transform: "translate(-739.964 -91.298)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46973",
    "data-name": "Path 46973",
    d: "M887.142,114.776a3.427,3.427,0,0,1-.132-1.414c.035-.293.377-1.176-.189-1.176-.533,0-.586.89-.614,1.267a4.046,4.046,0,0,0,.178,1.505c.15.476.9.3.756-.184",
    transform: "translate(-782.466 -99.055)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46974",
    "data-name": "Path 46974",
    d: "M918.387,95.632l.895.348c.3.116.607.317.919.163a.343.343,0,0,0,.134-.454c-.118-.294-.565-.369-.837-.474l-.9-.343a.4.4,0,0,0-.486.272.4.4,0,0,0,.272.486",
    transform: "translate(-810.634 -83.751)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46975",
    "data-name": "Path 46975",
    d: "M827.241,20.092c-1.561-2.052-1.545-2.068-1.788-2.207a.343.343,0,0,0-.5.372c.073.284.066.236,1.716,2.389a.4.4,0,0,0,.564.01.409.409,0,0,0,.01-.564",
    transform: "translate(-728.379 -15.753)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46976",
    "data-name": "Path 46976",
    d: "M873.056,9.148a5.911,5.911,0,0,0,.013-1.267c-.038-.393-.044-1-.463-1.171a.294.294,0,0,0-.293.074c-.263.3-.062.8-.028,1.16a7.017,7.017,0,0,1,0,1.191.39.39,0,0,0,.379.393.4.4,0,0,0,.393-.379",
    transform: "translate(-770.089 -5.911)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46977",
    "data-name": "Path 46977",
    d: "M915.19,15.272c.021-.193-.163-.322-.33-.342-.343-.042-.672.366-.892.589a6.782,6.782,0,0,0-.7.838.393.393,0,0,0,.137.533.4.4,0,0,0,.533-.137c.84-1.092,1.2-1,1.25-1.481",
    transform: "translate(-806.32 -13.18)",
    fill: "#f48c7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46978",
    "data-name": "Path 46978",
    d: "M1466.962,55.9l-.8,1.988-3.34-.928-1.523,2.763-2.613-.286-.145,1.323,3.495.383,1.443-2.618,3.475.966,1.2-2.991Z",
    transform: "translate(-1287.818 -49.359)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46979",
    "data-name": "Path 46979",
    d: "M1967.5,152.34a15.712,15.712,0,0,0-8.685,1.367,27.958,27.958,0,0,0-7.741,6.551l5.848,4.01s-.6-6.88,10.579-11.928",
    transform: "translate(-1722.697 -134.395)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46980",
    "data-name": "Path 46980",
    d: "M2076.751,95.321l.733-3.795-2.71-2.756a.531.531,0,0,1,.313-.9l3.836-.475,1.783-3.429a.531.531,0,0,1,.952.02l1.637,3.5,3.813.636a.531.531,0,0,1,.275.912l-2.824,2.639.573,3.822a.531.531,0,0,1-.782.544l-3.383-1.87L2077.51,95.9a.531.531,0,0,1-.759-.576",
    transform: "translate(-1831.782 -73.886)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46981",
    "data-name": "Path 46981",
    d: "M93.693,433.4a15.712,15.712,0,0,1,8.685,1.367,27.958,27.958,0,0,1,7.741,6.551l-5.847,4.01s.6-6.88-10.579-11.928",
    transform: "translate(-82.726 -382.553)",
    fill: "#fae0b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46982",
    "data-name": "Path 46982",
    d: "M10.8,376.377l-.733-3.795,2.711-2.755a.531.531,0,0,0-.313-.9l-3.836-.475-1.783-3.429a.531.531,0,0,0-.952.02l-1.637,3.5-3.813.636a.531.531,0,0,0-.275.912l2.824,2.639-.573,3.822a.531.531,0,0,0,.782.544l3.383-1.87,3.458,1.726a.531.531,0,0,0,.759-.576",
    transform: "translate(0 -322.043)",
    fill: "#ffcc43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46983",
    "data-name": "Path 46983",
    d: "M1630.227,36.968a1.894,1.894,0,1,1-1.895-1.895,1.894,1.894,0,0,1,1.895,1.895",
    transform: "translate(-1436.06 -30.968)",
    fill: "#009081"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46984",
    "data-name": "Path 46984",
    d: "M2229.822,52.843a1.583,1.583,0,1,1-1.583-1.583,1.583,1.583,0,0,1,1.583,1.583",
    transform: "translate(-1966.021 -45.26)",
    fill: "#b75742"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46985",
    "data-name": "Path 46985",
    d: "M1755.7,130.962a1.611,1.611,0,1,1-1.611-1.611,1.611,1.611,0,0,1,1.611,1.611",
    transform: "translate(-1547.348 -114.21)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46990",
    "data-name": "Path 46990",
    d: "M1755.7,130.962a1.611,1.611,0,1,1-1.611-1.611,1.611,1.611,0,0,1,1.611,1.611",
    transform: "translate(-1542.636 -74.23)",
    fill: "#f79c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46986",
    "data-name": "Path 46986",
    d: "M147.34,191.643a1.787,1.787,0,1,1-1.787-1.787,1.787,1.787,0,0,1,1.787,1.787",
    transform: "translate(-126.938 -167.633)",
    fill: "#466eb6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46987",
    "data-name": "Path 46987",
    d: "M151.65,583.9a.809.809,0,1,1-.809-.809.809.809,0,0,1,.809.809",
    transform: "translate(-132.47 -514.837)",
    fill: "#9bc1f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46988",
    "data-name": "Path 46988",
    d: "M2307.215,605.133a1.211,1.211,0,1,1-1.211-1.211,1.211,1.211,0,0,1,1.211,1.211",
    transform: "translate(-2035.012 -533.232)",
    fill: "#fae0b2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrymyaiClawson);
export default __webpack_public_path__ + "static/media/trymyai-clawson.7e961c284cdd24dc757a28da6c4309bc.svg";
export { ForwardRef as ReactComponent };